'use strict';
import {module} from '../app';

module.service('WorklistFilterSettings', [
  'AjaxService', 'authService', function (AjaxService, authService) {
    return {
      getMySettings: function () {
        return AjaxService.getAndCache(authService.currentMagViewUrl() + '/api/worklistFilterSettings/mySettings');
      },
      saveMySettings: function (settings) {
        return AjaxService.post(authService.currentMagViewUrl() + '/api/worklistFilterSettings/mySettings', settings);
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/domains/worklistFilterSettings.js